var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.selectedGoalsArray.length > 0
    ? _c("div", { staticClass: "selected-goals-areas" }, [
        _vm.readonly
          ? _c("span", { staticClass: "gray-chip" }, [
              _vm._v(" Metas Académicas Relacionada(s) ")
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "py-2" },
          [
            _vm._l(_vm.selectedGoalsArray, function(goal, indexGoal) {
              return _c(
                "div",
                {
                  key: `reason-item-${indexGoal}`,
                  staticClass: "reason-item px-3 d-inline-block mr-2 mb-2"
                },
                [
                  _c("span", { staticClass: "color-black font-16" }, [
                    _vm._v(" " + _vm._s(goal.name) + " ")
                  ]),
                  _c(
                    "span",
                    { staticClass: "color-black font-16 font-weight-bold" },
                    [_vm._v(" " + _vm._s(goal.area) + " ")]
                  ),
                  !_vm.readonly
                    ? _c("i", {
                        staticClass:
                          "far fa-times-circle text-red font-16 cursor-pointer ml-2",
                        on: {
                          click: function($event) {
                            return _vm.onDeleteItemHandler(indexGoal)
                          }
                        }
                      })
                    : _vm._e()
                ]
              )
            }),
            _c("div", {
              staticClass: "dropdown-divider mt-0 pb-2 ml-3 mt-3 mb-1"
            })
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }